import { ExpandableContentWrapper, ZeroDTEChart } from 'components';
import { CanvasContentId } from 'types/canvas';
import { CanvasGroupLinkButton } from 'components/canvas/groups';

interface CanvasZeroDTEEquityVolProps {
  id: number;
  sym: string;
}

const CanvasZeroDTEEquityVol = ({ id, sym }: CanvasZeroDTEEquityVolProps) => (
  <ExpandableContentWrapper
    type={CanvasContentId.ZERO_DTE_EQUITY_VOL_CHART}
    styleOverrides={{ p: 1, height: '100%' }}
  >
    <ZeroDTEChart
      isSentiment
      selectedSym={sym}
      headerExtras={
        <CanvasGroupLinkButton
          componentId={id}
          contentId={CanvasContentId.ZERO_DTE_EQUITY_VOL_CHART}
        />
      }
    />
  </ExpandableContentWrapper>
);

export default CanvasZeroDTEEquityVol;
